import { createFileRoute } from '@tanstack/react-router';
import PerfusionDeviceList from '../../../../Components/PerfusionDeviceList';
import { useCanViewPerfusionDevices } from '../../../../Hooks/featurePermission';
import PerfusionDeviceMessages from '../../../../Lang/perfusion-device';
import { useFeaturePermissions } from '../../../../Selectors/Permission';

export const Route = createFileRoute('/(main)/_layout/devices/')({
  component: RouteComponent,
});

function RouteComponent() {
  const canViewPerfusionDevices = useCanViewPerfusionDevices();
  const featurePermissions = useFeaturePermissions();

  if (!canViewPerfusionDevices) {
    return (
      <div className="perfusion-devices-page perfusion-devices-message">
        {featurePermissions.perfusionDevices
          ? PerfusionDeviceMessages.noListAccess
          : PerfusionDeviceMessages.featureDisabled}
      </div>
    );
  }

  return <PerfusionDeviceList />;
}
